import styled from "styled-components";
import { BASIC_WHITE } from "../../constants/colors";
import { Button } from "../atoms/Button";

type Props = {
  onReturn: () => void;
};

export const AppCouponListFooter: React.FC<Props> = ({ onReturn }) => {
  return (
    <FooterContainer>
      <FooterContent>
        <Button text="戻る" btnStyle="secondary" onClick={onReturn} />
      </FooterContent>
    </FooterContainer>
  );
};

const FooterContainer = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  min-width: 375px;
  z-index: 9998;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${BASIC_WHITE};
  padding: 12px;
`;
